import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { acceptEula } from '../../actions/auth/actionCreators';
import { fetchProfile } from '../../actions/profile/actionCreators';
import Modal from '../shared/Modal';
import StaticPage from '../shared/StaticPage';
import { notifyError } from '../../utils/notifier';


export class EULAModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      saving: false
    };

    this.onConfirm = this.onConfirm.bind(this);
  }

  onConfirm() {
    const {
      acceptEula,
      fetchProfile,
      currentUserId
    } = this.props;
    this.setState({ saving: true });
    acceptEula()
      .then(() => fetchProfile(currentUserId))
      .catch(() => notifyError())
      .then(() => this.setState({ saving: false }));
  }

  render() {
    const { saving } = this.state;
    return (
      <Modal
        isOpen={true}
        size={'lg'}
        header='End User License Agreement'
        showCancelButton={false}
        onConfirm={this.onConfirm}
        confirmButtonText='Accept'
        confirmButtonLoading={saving}
      >
        <StaticPage url='/content/license/index.html' />
      </Modal>
    );
  }
}

EULAModal.propTypes = {
  acceptEula: PropTypes.func,
  fetchProfile: PropTypes.func,
  currentUserId: PropTypes.string,
};

const mapStateToProps = ({ auth }) => ({
  currentUserId: auth.userId,
});

const mapDispatchToProps = (dispatch) => ({
  acceptEula: () => dispatch(acceptEula()),
  fetchProfile: (currentUserId) => dispatch(fetchProfile(currentUserId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EULAModal);



// WEBPACK FOOTER //
// src/components/license/EULAModal.js